(function () {
  'use strict';

  var drawer = null;
  var trigger = null;
  var isUpdating = false;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (trigger) trigger.focus();
  }

  function updateBadge(count) {
    var bag = document.querySelector('.site-header__bag');
    if (!bag) return;
    var badge = bag.querySelector('.site-header__bag-count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'site-header__bag-count';
        badge.setAttribute('aria-hidden', 'true');
        bag.appendChild(badge);
      }
      badge.textContent = count;
    } else {
      if (badge) badge.remove();
    }
    bag.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count !== 1 ? 's' : ''));
  }

  /* Replace the full panel content (recs + cart) from a fresh section render */
  function refreshDrawerContent() {
    return fetch('/?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newPanel = doc.querySelector('.cart-drawer__panel');
        var currentPanel = drawer.querySelector('.cart-drawer__panel');
        if (newPanel && currentPanel) {
          currentPanel.className = newPanel.className;
          currentPanel.innerHTML = newPanel.innerHTML;
        }
      });
  }

  function cartChange(key, quantity) {
    if (isUpdating) return Promise.resolve();
    isUpdating = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateBadge(cart.item_count);
        return refreshDrawerContent();
      })
      .catch(function (err) { console.error('Cart update failed', err); })
      .finally(function () { isUpdating = false; });
  }

  function addVariantToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateBadge(cart.item_count);
        return refreshDrawerContent();
      })
      .catch(function (err) { console.error('Recommendation add failed', err); });
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    var originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add to bag');
          });
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateBadge(cart.item_count);
        return refreshDrawerContent();
      })
      .then(function () {
        if (button) { button.textContent = originalLabel; button.disabled = false; }
        var errorEl = form.querySelector('[data-form-error]');
        if (errorEl) errorEl.remove();
        openDrawer();
      })
      .catch(function (err) {
        if (button) { button.textContent = originalLabel; button.disabled = false; }
        var errorEl = form.querySelector('[data-form-error]');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.className = 'product__form-error';
          errorEl.setAttribute('data-form-error', '');
          if (button) button.insertAdjacentElement('afterend', errorEl);
          else form.appendChild(errorEl);
        }
        errorEl.textContent = err.message;
      });
  }

  /* ---- Focus trap ---- */
  function getFocusable() {
    var panel = drawer.querySelector('.cart-drawer__panel');
    if (!panel) return [];
    return Array.from(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function trapFocus(e) {
    if (!drawer.classList.contains('is-open')) return;
    var focusable = getFocusable();
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  }

  /* ---- Event delegation inside drawer ---- */
  function onDrawerClick(e) {
    /* Remove item */
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      cartChange(removeBtn.dataset.cartRemove, 0);
      return;
    }

    /* Qty –/+ buttons */
    var qtyBtn = e.target.closest('[data-cart-qty-change]');
    if (qtyBtn) {
      var key = qtyBtn.dataset.cartLineKey;
      var currentQty = parseInt(qtyBtn.dataset.currentQty, 10) || 0;
      var delta = parseInt(qtyBtn.dataset.cartQtyChange, 10);
      var newQty = currentQty + delta;
      cartChange(key, newQty < 1 ? 0 : newQty);
      return;
    }

    /* Recommendation quick-add — must precede PDP link check */
    var recAddBtn = e.target.closest('[data-rec-add]');
    if (recAddBtn) {
      e.preventDefault();
      addVariantToCart(recAddBtn.dataset.recAdd);
      return;
    }

    /* Recommendation PDP navigation — close drawer then navigate */
    var recPdpLink = e.target.closest('[data-rec-pdp]');
    if (recPdpLink) {
      e.preventDefault();
      var href = recPdpLink.getAttribute('href');
      closeDrawer();
      window.location.href = href;
      return;
    }
  }

  /* ---- Boot ---- */
  document.addEventListener('DOMContentLoaded', function () {
    drawer = document.getElementById('cart-drawer');
    trigger = document.querySelector('[data-cart-drawer-toggle]');

    if (!drawer) return;

    /* Open */
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    }

    /* Close — any element with data-cart-drawer-close */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) closeDrawer();
    });

    /* Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      trapFocus(e);
    });

    /* All cart + recommendation interactions via delegation */
    drawer.addEventListener('click', onDrawerClick);

    /* Open drawer if redirected from /cart with ?open_cart param */
    var params = new URLSearchParams(window.location.search);
    if (params.has('open_cart')) {
      openDrawer();
      params.delete('open_cart');
      var newUrl = window.location.pathname + (params.toString() ? '?' + params : '') + window.location.hash;
      history.replaceState({}, '', newUrl);
    }

    /* Intercept product form add-to-cart submissions */
    document.querySelectorAll('[data-product-form] form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(form);
      });
    });

    /* Expose for cross-script use (quick-add on collection pages) */
    window.openCartDrawer = openDrawer;
    window.refreshCartDrawer = refreshDrawerContent;
    window.updateBagCount = function () {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateBadge(cart.item_count); });
    };
  });
})();
